<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Konsumen Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="employeeForm" validated novalidate @submit="editCustomer">
          
            <div v-if="loading == false">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Outlet">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.customerForm.name.$model"
                      :state="!$v.customerForm.name.$invalid"
                      required
                      placeholder="Nama Konsumen"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Konsumen harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="customer_group" label="Group Outlet">
                    <model-select
                      id="customer_group"
                      :options="listCustomerGroup"
                      v-model="$v.customerForm.customer_group.$model"
                      :isError="$v.customerForm.customer_group.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                      @input="setSelected"
                      :isDisabled="allowEdit"
                    ></model-select>
                    <div
                      v-if="customerForm.customer_group === null"
                      class="invalid-feedback-custom"
                    >Group konsumen harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="vehicle_delivery_id" label="Kendaraan yang mengirim">
                    <model-select
                      id="vehicle_delivery_id"
                      :options="listVehicleDelivery"
                      v-model="$v.customerForm.vehicle_delivery_id.$model"
                      :isError="$v.customerForm.vehicle_delivery_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="order_time_id" label="Waktu Pemesanan">
                    <model-select
                      id="order_time_id"
                      :options="listOrderTime"
                      v-model="$v.customerForm.order_time_id.$model"
                      :isError="$v.customerForm.order_time_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <!-- <div
                      v-if="customerForm.order_time_id === null"
                      class="invalid-feedback-custom"
                    >Waktu pemesanan harus di isi.</div>-->
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="province" label="Provinsi">
                    <model-select
                      id="province"
                      :options="listProvince"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.province.$model"
                        @input="filterRegency"
                      :isError="$v.customerForm.province.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.province === null"
                      class="invalid-feedback-custom"
                    >Provinsi harus di isi.</div>
                  </b-form-group>
                </b-col>
                 <b-col sm="3">
                  <b-form-group label-for="regencies" label="Regensi">
                    <model-select
                      id="regencies"
                      :options="listRegencies"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.regencies.$model"
                      @input="filterDistrict"
                      :isError="$v.customerForm.regencies.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.regencies === null"
                      class="invalid-feedback-custom"
                    >Regensi harus di isi.</div>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="district" label="Distrik">
                    <model-select
                      id="district"
                      :options="listDistrict"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.district.$model"
                      @input="filterVillage"
                      :isError="$v.customerForm.district.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.district === null"
                      class="invalid-feedback-custom"
                    >Distrik harus di isi.</div>
                  </b-form-group>
                </b-col>

                 <b-col sm="3">
                  <b-form-group label-for="village" label="Kampung">
                    <model-select
                      id="village"
                      :options="listVillage"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.villages.$model"
                      :isError="$v.customerForm.villages.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.villages === null"
                      class="invalid-feedback-custom"
                    >Kampung harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="zone" label="Zona">
                    <model-select
                      id="zone"
                      :options="listZone"
                      v-model="$v.customerForm.zone.$model"
                      :isError="$v.customerForm.zone.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.zone === null"
                      class="invalid-feedback-custom"
                    >Zona harus di isi.</div>
                  </b-form-group>
                </b-col>
                
                <b-col sm="3">
                  <b-form-group label-for="owner_name" label="Nama Pemilik">
                    <b-form-input
                      id="owner_name"
                      type="text"
                      v-model="$v.customerForm.owner_name.$model"
                      :state="!$v.customerForm.owner_name.$invalid"
                      required
                      placeholder="Nama Pemilik"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama pemilik harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="lat" label="Lat">
                    <b-form-input
                      id="lat"
                      type="text"
                      v-model="$v.customerForm.lat.$model"
                      :state="!$v.customerForm.lat.$invalid"
                      required
                      placeholder="Latitude"
                    ></b-form-input>
                    <b-form-invalid-feedback>Latitude harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="lng" label="Lng">
                    <b-form-input
                      id="lng"
                      type="text"
                      v-model="$v.customerForm.lng.$model"
                      :state="!$v.customerForm.lng.$invalid"
                      required
                      placeholder="Longitude"
                    ></b-form-input>
                    <b-form-invalid-feedback>Longitude harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="mobile_phone" label="No HP">
                    <b-form-input
                      id="mobile_phone"
                      type="text"
                      v-model="$v.customerForm.mobile_phone.$model"
                      :state="!$v.customerForm.mobile_phone.$invalid"
                      required
                      placeholder="No HP"
                    ></b-form-input>
                    <b-form-invalid-feedback>No HP harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="mobile_phone2" label="No HP-2">
                    <b-form-input
                      id="mobile_phone2"
                      type="text"
                      v-model="$v.customerForm.mobile_phone2.$model"
                      :state="!$v.customerForm.mobile_phone2.$invalid"
                      placeholder="No HP-2"
                    ></b-form-input>
                    <b-form-invalid-feedback>No HP 2 harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="mobile_phone3" label="No HP-3">
                    <b-form-input
                      id="mobile_phone3"
                      type="text"
                      v-model="$v.customerForm.mobile_phone3.$model"
                      :state="!$v.customerForm.mobile_phone3.$invalid"
                      placeholder="No HP-3"
                    ></b-form-input>
                    <b-form-invalid-feedback>No HP 3 harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="bank_account_name" label="Nama Rekening">
                    <b-form-input
                      id="bank_account_name"
                      type="text"
                      v-model="$v.customerForm.bank_account_name.$model"
                      :state="!$v.customerForm.bank_account_name.$invalid"
                      placeholder="Nama Rekening"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Rekening harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="bank_account_number" label="Nomor Rekening">
                    <b-form-input
                      id="bank_account_number"
                      type="text"
                      v-model="$v.customerForm.bank_account_number.$model"
                      :state="!$v.customerForm.bank_account_number.$invalid"
                      placeholder="Nomor Rekening"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nomor Rekening harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3" v-if="customerForm.flag === '2'">
                  <!-- <b-form-group v-if="customerForm.flag !== '2'" label-for="source_delivery" label="Dikirim dari">
                    <model-select
                      id="source_delivery"
                      :options="listSourceDelivery"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.source_delivery.$model"
                      :isError="$v.customerForm.source_delivery.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.source_delivery === null"
                      class="invalid-feedback-custom"
                    >Asal pengiriman harus di isi.</div>
                    <div
                      v-if="isReadonly"
                      class="invalid-feedback-custom"
                    >Silahkan kontak SVP atau Manager anda.</div>
                  </b-form-group> -->

                  <b-form-group label-for="route_delivery" label="Rute Pengiriman">
                    <model-select
                      id="route_delivery"
                      :options="listRoute"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.route_delivery.$model"
                      :isError="$v.customerForm.route_delivery.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.route_delivery === null"
                      class="invalid-feedback-custom"
                    >Rute pengiriman harus di isi.</div>
                    <div
                      v-if="isReadonly"
                      class="invalid-feedback-custom"
                    >Silahkan kontak SVP atau Manager anda.</div>
                  </b-form-group>

                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="status" label="Status Konsumen">
                    <model-select
                      id="status"
                      :options="listCustomerStatus"
                      v-model="$v.customerForm.status.$model"
                      :isError="$v.customerForm.status.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.status === null"
                      class="invalid-feedback-custom"
                    >Status harus di isi.</div>
                  </b-form-group>
                </b-col>
                 <b-col sm="3">
                  <b-form-group label-for="company_for_letter" label="Nama PT. Di surat jalan">
                    <model-select
                      id="company_for_letter"
                      :options="listCompanyForLetter"
                      v-model="$v.customerForm.company_for_letter.$model"
                      :isError="$v.customerForm.company_for_letter.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.company_for_letter === null"
                      class="invalid-feedback-custom"
                    >Nama PT. Di surat jalan harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="address" label="Alamat Penempatan Asset">
                    <b-form-textarea
                      id="address"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.customerForm.address.$model"
                      :state="!$v.customerForm.address.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="customerForm.flag === '2'">
                <b-col sm="3">
                  <b-form-group label-for="customer_code" label="Kode Konsumen">
                    <b-form-input
                      id="customer_code"
                      type="text"
                      v-model="$v.customerForm.customer_code.$model"
                      :state="!$v.customerForm.customer_code.$invalid"
                      required
                      placeholder="Kode Konsumen"
                    ></b-form-input>
                    <b-form-invalid-feedback>Kode Konsumen harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="bill_address" label="Alamat Penagihan">
                    <model-select
                      id="bill_address"
                      :options="listBillAddress"
                      :isDisabled="isReadonly"
                      v-model="$v.customerForm.bill_address.$model"
                      :isError="$v.customerForm.bill_address.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerForm.bill_address === null"
                      class="invalid-feedback-custom"
                    >Alamat penagihan harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="nomor_ktp" label="Nomor Induk Kependudukan">
                    <b-form-input
                      id="nomor_ktp"
                      type="text"
                      v-model="$v.customerForm.ktp_number.$model"
                      :state="!$v.customerForm.ktp_number.$invalid"
                      required
                      placeholder="Nomor Induk Kependudukan"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nomor Induk Kependudukan harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="address_ktp" label="Alamat KTP">
                    <b-form-textarea
                      id="address_ktp"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.customerForm.address_ktp.$model"
                      :state="!$v.customerForm.address_ktp.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

              </b-row>
              

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button v-if="!isReadonly" type="submit" size="sm" variant="primary" :disabled="$v.customerForm.$invalid" >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>

            <div v-else>
              <loading></loading>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Penempatan Asset" active>
          <asset-placement
            :customer="customerForm"
            :customer-asset="customerAsset"
            :list-asset-owner="listAssetOwner"
            :list-status-customer-asset="listStatusCustomerAsset"
            :list-employee="listEmployee"
            :child-add-button="false"
            :is-disable="isReadonly"
            :loading="loading"
            @reload="getCustomerDetail"
          ></asset-placement>
        </b-tab>

        <b-tab title="Penempatan Asset Alternative">
          <asset-placement-alter
            :customer="customerForm"
            :customer-asset="customerAsset"
            :list-asset-owner="listAssetOwner"
            :list-status-customer-asset="listStatusCustomerAsset"
            :list-employee="listEmployee"
            :child-add-button="childAddButton"
            :is-disable="isReadonly"
            :loading="loading"
            @reload="getCustomerDetail"
          ></asset-placement-alter>
        </b-tab>

        <b-tab title="Penarikan Asset">
          <asset-return
            :customer="customerForm"
            :customer-asset-return="customerAssetReturn"
            :customer-asset-avail="customerAsset"
            :list-asset-status="listAssetStatus"
            :loading="loading"
            :is-disable="isReadonly"
            :child-add-button="false"
            :list-employee="listEmployee"
            @reload="getCustomerDetail"
          ></asset-return>
        </b-tab>

        <b-tab title="Dokumen Konsumen">
          <document-customer
            :customer-document="customerDocument"
            :customer="customerForm"
            :loading="loading"
            :list-document="listDocument"
            :is-disable="isReadonly"
            :child-add-button="childAddButton"
            @reload="getCustomerDetail"
          ></document-customer>
        </b-tab>

         <b-tab title="Group Outlet History">
          <customer-group-history
            :customer-group-history="customerGroupHistory"
            :loading="loading"
            :is-disable="isReadonly"
            :child-add-button="false"
            @reload="getCustomerDetail"
          ></customer-group-history>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import assetPlacement from "./tabs/AssetPlacement";
import assetPlacementAlter from "./tabs/AssetPlacementAlter";
import documentCustomer from "./tabs/DocumentCustomer";
import assetReturn from "./tabs/AssetReturn";
import customerGroupHistory from "./tabs/CustomerGroupHistory";
import loading from "@/templates/Loading.vue";

export default {
  name: "customer",
  components: { globalTable, ModelSelect, MultiSelect, assetPlacement, documentCustomer, assetReturn,assetPlacementAlter,customerGroupHistory, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      customer: [],
      customerAsset: [],
      customerAssetReturn: [],
      customerDocument: [],
      customerGroupHistory: [],
      listCustomerGroup: [],
      listAssetOwner: [],
      listBillAddress: [],
      listVehicleDelivery: [],
      listSourceDelivery: [],
      listOrderTime: [],
      listEmployee: [],
      listAssetStatus: [],
      listDocument:[],
      listRoute: [],
      listCompanyForLetter: [],
      listProvince: [],
      listRegencies: [],
      listDistrict: [],
      listVillage: [],
      old_zone: null,
      ownerAssetSelected: [],
      listCustomerStatus: [
        { value: "1", text: "Aktif" },
        { value: "2", text: "Non Aktif" }
      ],
      listStatusCustomerAsset: [
        { value: "1", text: "Dipakai" },
        { value: "2", text: "Dikembalikan" }
      ],
      listZone: [],
      listAsset: [],
      isEdit: false,
      loading: true,
      fieldsCustomerDocument: [
        { key: "document_name_preview", label: "Nama" },
        { key: "action", label: "Action", class: "text-center width-80" }
      ],
      customerForm: interfaces.customer,
      customerAssetForm: interfaces.customer_asset,
      customerDocumentForm: interfaces.customer_document,
      selectedAttachmentFile: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations() {

    if (this.customerForm.flag === "2") { 
       return custom_validation.customer_details.customer_group_indomaret_detail_true;
    } else {
        return custom_validation.customer_details.customer_group_notindomaret_detail_true;
    }
    
  },
  computed: {
    childAddButton() {
      let nik = localStorage.getItem("nik");
      return (['13', '9', '11'].includes(localStorage.getItem("division_id")) || localStorage.getItem("level") === "1" || [ 'MBS22090004'].includes(nik)) ? true : false;
    },
    isReadonly() {
      let nik = localStorage.getItem("nik");
      return localStorage.getItem("level") === "1" ||
        localStorage.getItem("level") === "2"  || [ 'MBS22090004', 'MBS25020007'].includes(nik)
        ? false
        : true;
    },
    allowEdit() {
      let nik = localStorage.getItem("nik");
      return localStorage.getItem("level") === "1" ||
        localStorage.getItem("level") === "2"  || (['MBS19080016', 'MBS22090004', 'MBS25020007', 'MBS25100001'].includes(nik)) ? false: true;
    }
  },
  methods: {
    init: function(cust_id) {
      this.loading = true;
      this.getCustomerDetail(cust_id);
      this.getDropdown();
      this.isEdit = false;
     
    },
    getCustomerDetail(cust_id) {
      this.axios
        .get("web/customer/detail/" + cust_id + "/")
        .then(response => {
          this.customerForm = response.data.data;
          this.old_zone = this.customerForm.zone;
          this.customerAsset = response.data.customer_assets;
          this.customerDocument = response.data.customer_document;
          this.customerGroupHistory = response.data.customer_group_history;
          this.customerAssetReturn = response.data.customer_assets_return;
          this.custom_validation.customer_detail.true.customerForm.customer_code = {};
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
           this.callRegencies();
           this.callDistrict();
           this.callVillage();
        });
    },
    filterRegency: function(){
      this.customerForm.regencies = null;
      this.customerForm.district = null;
      this.customerForm.villages = null;
      this.listRegencies = [];
      this.listDistrict = [];
      this.listVillage = [];
      this.axios.get("/web/dropdown/regency/" + this.customerForm.province)
      .then((response) => {
        this.listRegencies = response.data.data;
      });
    },
    filterDistrict: function(){
      this.customerForm.district = null;
      this.customerForm.villages = null;
      this.listDistrict = [];
      this.listVillage = [];
      this.customerForm.zone = null;
      this.axios.get("/web/dropdown/district/" + this.customerForm.regencies)
      .then((response) => {
        this.listDistrict = response.data.data;
      });
    },
    filterVillage: function(){
      this.customerForm.villages = null;
      this.listVillage = [];
      this.axios.get("/web/dropdown/village/" + this.customerForm.district)
      .then((response) => {
        this.listVillage = response.data.data;
        this.customerForm.zone = (response.data.zone === null) ? this.old_zone : response.data.zone;
      });
    },
     callRegencies: function(){
      this.axios.get("/web/dropdown/regency/" + this.customerForm.province)
      .then((response) => {
        this.listRegencies = response.data.data;
      });
    },
    callDistrict: function(){
      this.axios.get("/web/dropdown/district/" + this.customerForm.regencies)
      .then((response) => {
        this.listDistrict = response.data.data;
      });
    },
    callVillage: function(){
      this.axios.get("/web/dropdown/village/" + this.customerForm.district)
      .then((response) => {
        this.listVillage = response.data.data;
      });
    },
    getDropdown() {
      this.axios
        .get("web/dropdown/dropdown-customer/")
        .then(response => {
          this.listCustomerGroup = response.data.customer_group;
          this.listZone = response.data.zone;
          this.listOrderTime = response.data.order_time;
          this.listVehicleDelivery = response.data.vehicle_delivery;
          this.listAssetOwner = response.data.asset_owner;
          this.listSourceDelivery = response.data.distribution_center;
          this.listBillAddress = response.data.billing_address;
          this.listEmployee = response.data.employee;
          this.listDocument = response.data.document_type;
          this.listRoute = response.data.route;
          this.listCompanyForLetter = response.data.company_for_letter;
          this.listProvince = response.data.province;
          this.listAssetStatus = response.data.asset_status;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    back: function() {
      this.$router.go(-1);
    },
    setSelected(event) {
      let temp = this.listCustomerGroup.filter(x=>x.value === event);
      this.customerForm.flag = temp[0].flag;
    },
    cancelCustomerDocument: function() {
      this.resetCustomerDocument();
      this.$refs.customerDocumentForm.hide();
      this.$refs["inputDocument"].reset();
    },
    editCustomer: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah konsumen ini ?")) {
        let customers = this.customerForm;
        this.axios
          .put("web/customer/change-customer/", this.customerForm)
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Ubah Konsumen Detail",
              message: response.data.message
            });
          })
          .catch(error => {
            this.expired(error, "Ubah Konsumen Detail");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>

<style>
</style>
